import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  ref: "canvas",
  class: "game-canvas"
}
const _hoisted_2 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_3 = { class: "loading-content" }
const _hoisted_4 = {
  key: 0,
  class: "controls-overlay"
}
const _hoisted_5 = { class: "controls-panel" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("canvas", _hoisted_1, null, 512),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "loading-logo" }, [
                  _createTextVNode("Lasantha"),
                  _createElementVNode("span", { class: "accent" }, ".dev")
                ], -1)),
                _createVNode(_Transition, {
                  name: "msg",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock("p", {
                      class: "loading-sub",
                      key: _ctx.loadingMessage
                    }, _toDisplayString(_ctx.loadingMessage), 1))
                  ]),
                  _: 1
                }),
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "loading-bar-track" }, [
                  _createElementVNode("div", { class: "loading-bar-fill" })
                ], -1))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (!_ctx.isLoading && _ctx.showControls)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "welcome-text" }, [
            _createElementVNode("h1", null, [
              _createTextVNode("Welcome to "),
              _createElementVNode("span", { class: "accent" }, "Lasantha.dev")
            ]),
            _createElementVNode("p", { class: "tagline" }, "Explore the island to discover my skills, projects & story.")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _cache[3] || (_cache[3] = _createStaticVNode("<h2 data-v-11822d2c>Controls</h2><ul data-v-11822d2c><li data-v-11822d2c><span class=\"key\" data-v-11822d2c>W A S D</span> Move</li><li data-v-11822d2c><span class=\"key\" data-v-11822d2c>Shift</span> + <span class=\"key\" data-v-11822d2c>W/A/D</span> Run</li><li data-v-11822d2c><span class=\"key\" data-v-11822d2c>Shift</span> + <span class=\"key\" data-v-11822d2c>Space</span> Running Jump</li><li data-v-11822d2c><span class=\"key\" data-v-11822d2c>B</span> Bonus Key</li><li data-v-11822d2c><span class=\"key\" data-v-11822d2c>Scroll</span> Zoom in / out</li><li data-v-11822d2c><span class=\"key\" data-v-11822d2c>Click</span> Lock mouse / look around</li><li data-v-11822d2c><span class=\"key\" data-v-11822d2c>ESC</span> Release mouse</li></ul><p class=\"desktop-note\" data-v-11822d2c>🖥️ Best experienced on desktop with a keyboard &amp; mouse.</p>", 3)),
            _createElementVNode("button", {
              class: "start-btn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startExploring && _ctx.startExploring(...args)))
            }, "Explore Lasantha's Skill Island")
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}